<div class="background-color mt-1">
  @if (isSOSButtonPressed) {
    <div class="overlay"></div>
  }

  <div class="section main-part-scroll">
    <div class="fullWidth">
      @if (isPageLoad) {
        @if (updateTask === "updateJob") {
          <div
            [ngStyle]="{
              'padding-bottom': bottomSectionFixedHeight,
            }"
          >
            <div>
              @if (!offlineMode) {
                @if (!largeView && groupUserCount > 1) {
                  <div
                    id="sos-slider"
                    class="slider"
                    [class.slider-pressed]="isSOSButtonPressed"
                    #slider
                    (pointerdown)="startSwipe($event)"
                    (pointermove)="moveSlider($event, confirmSOSTemplate)"
                    (pointerup)="endSwipe($event, confirmSOSTemplate)"
                  >
                    @if (isSOSButtonPressed) {
                      <div class="slider-track">
                        <span class="slide-text"> Slide to Send SOS </span>

                        <div
                          class="sos-dragger"
                          [style.transform]="'translateX(' + translateX + 'px)'"
                        >
                          SOS
                        </div>
                      </div>
                    } @else {
                      <div
                        class="text-danger text-uppercase fs-5 px-2 text-end w-100 pt-2"
                      >
                        <span
                          role="button"
                          (pointerdown)="isSOSButtonPressed = true"
                          (pointermove)="isSOSButtonPressed = true"
                          (pointerup)="isSOSButtonPressed = false"
                        >
                          SOS
                        </span>
                      </div>
                    }
                  </div>
                }
                <div class="d-flex flex-wrap">
                  @if (showGettingStartedGuide) {
                    <div class="col-12 col-md-6 col-lg-4 col-xl-3">
                      <gtapp-getting-started
                        (emitEvent)="showGuideOptions($event?.guideOptions)"
                      ></gtapp-getting-started>
                    </div>
                  }
                  <div style="flex: 1 1 0">
                    <div
                      class="d-flex flex-wrap text-dark align-items-start gap-lg-2"
                    >
                      @if (pinnedMessages?.length) {
                        <div class="p-2 py-3 p-lg-2 w-100">
                          <div class="d-flex flex-wrap gap-3">
                            @for (message of pinnedMessages; track $index) {
                              @if (
                                readPinnedMessages?.includes(message?.id) &&
                                !message?.show
                              ) {
                                <div
                                  role="button"
                                  class="px-3 py-3 py-lg-2 border rounded w-100 d-flex align-items-center pinned-message-card"
                                  (click)="message.show = true"
                                >
                                  <span class="small-font ms-1 pinned-min-text">
                                    {{ message?.message }}
                                  </span>
                                  <div class="text-end">
                                    <i
                                      class="fa-solid fa-thumbtack flex-shrink-0"
                                    ></i>
                                  </div>
                                </div>
                              } @else {
                                <div
                                  class="w-100 pinned-message-card"
                                  (click)="
                                    message?.show
                                      ? (message.show = false)
                                      : onMinimizeMessage(
                                          message,
                                          pinnedMessageTemplate
                                        )
                                  "
                                >
                                  <div class="float-end">
                                    <i
                                      class="fa-solid fa-thumbtack flex-shrink-0"
                                    ></i>
                                  </div>

                                  <div
                                    class="mb-3 overflow-45vh text-break gt-multi-line px-2 py-1"
                                  >
                                    {{ message?.message }}
                                  </div>

                                  <div class="text-end">
                                    <button
                                      class="btn btn-outline-secondary btn-sm text-dark"
                                    >
                                      Minimize
                                    </button>
                                  </div>
                                </div>
                              }
                            }
                          </div>
                        </div>
                      }
                      @if (
                        (subscriberStats?.active_site_count != 0 &&
                          !largeView) ||
                        dashBoardData?.pending_shifts ||
                        (dashBoardData?.missed_welfare_checks_exists &&
                          !hideMissedWelfareCheckInBtn) ||
                        subscriberStats?.live_count ||
                        subscriberStats?.event_log_exists ||
                        holReceivedExists ||
                        draftedHOLExists ||
                        (queuedResposeListData?.length && !largeView)
                      ) {
                        <div class="p-2 py-3 p-lg-2">
                          <div class="mb-2">
                            <dt>Navigation</dt>
                          </div>

                          <div class="d-flex flex-wrap gap-3">
                            @if (dashBoardData?.pending_shifts) {
                              <div
                                role="button"
                                class="bg-secondary-subtle p-2 px-3 border text-uppercase rounded newShifts fw-semibold small d-flex align-items-center"
                                (click)="redirectToPage('requireAcceptance')"
                              >
                                Roster Updated
                              </div>
                            }

                            @if (
                              dashBoardData?.missed_welfare_checks_exists &&
                              !hideMissedWelfareCheckInBtn
                            ) {
                              <div
                                role="button"
                                class="bg-danger p-2 px-3 border text-uppercase rounded d-flex align-items-center"
                                (click)="
                                  openMissedWelfareCheckInEvents(
                                    missedEventReasonTemplateRef
                                  )
                                "
                              >
                                <span class="fw-semibold small ms-1 text-white">
                                  Missed Welfare Checks
                                </span>
                              </div>
                            }
                            @if (
                              subscriberStats?.live_count ||
                              subscriberStats?.event_log_exists
                            ) {
                              <div
                                id="eventLogButton"
                                role="button"
                                class="bg-secondary-subtle p-2 px-3 border text-uppercase rounded"
                                (click)="redirectToPage('eventLog')"
                              >
                                <i class="fa-solid fa-book"></i>
                                <span class="fw-semibold small ms-1">
                                  Event Log
                                </span>
                              </div>
                            }
                            @if (queuedResposeListData?.length && !largeView) {
                              <div
                                role="button"
                                class="bg-warning-subtle p-2 px-3 border text-uppercase rounded d-flex align-items-center"
                                (click)="openQueuedTemplate()"
                              >
                                <i class="fa-solid fa-book"></i>
                                <span class="fw-semibold small ms-1">
                                  Queued Events [{{
                                    queuedResposeListData?.length
                                  }}]
                                </span>
                              </div>
                            }

                            @if (holReceivedExists) {
                              <div
                                role="button"
                                class="bg-warning p-2 px-3 border text-uppercase rounded d-flex align-items-center"
                                (click)="redirectToPage('handOverLog')"
                              >
                                <i class="fa-solid fa-calendar"></i>
                                <span class="fw-semibold small ms-1">
                                  Handover Logs
                                </span>
                              </div>
                            }
                            @if (draftedHOLExists) {
                              <div
                                role="button"
                                class="bg-warning p-2 px-3 border text-uppercase rounded d-flex align-items-center"
                                (click)="redirectToPage('addHandOverLog')"
                              >
                                <i class="fa-solid fa-calendar"></i>
                                <span class="fw-semibold small ms-1">
                                  Handover Log
                                </span>
                              </div>
                            }

                            @if (
                              subscriberStats?.active_site_count != 0 &&
                              !largeView
                            ) {
                              <div
                                role="button"
                                id="incidentsButton"
                                class="bg-primary p-2 px-3 border text-uppercase rounded d-flex align-items-center"
                                (click)="redirectToPage('incidents')"
                              >
                                <i class="fa-solid fa-file-lines"></i>
                                <span class="fw-semibold small ms-1 text-white">
                                  Incident Report
                                </span>
                              </div>
                            }
                          </div>
                        </div>
                      }

                      @if (
                        (isAdmin || isDispatchUser) &&
                        (dashBoardData?.invalid_qr_checkpoints ||
                          jobStats?.unassigned_jobs ||
                          jobStats?.unassigned_shifts ||
                          jobStats?.pending_shifts ||
                          jobStats?.stale_shifts ||
                          jobStats?.stale_jobs ||
                          (isAdmin && !largeView) ||
                          ((credStatData?.three_months ||
                            credStatData?.expired) &&
                            isAdmin))
                      ) {
                        <div id="management_tasks" class="p-2 py-3 p-lg-2">
                          <div class="mb-2">
                            <dt>Management Functions & Tasks</dt>
                          </div>

                          <div class="d-flex flex-wrap gap-3">
                            @if (dashBoardData?.invalid_qr_checkpoints) {
                              <div
                                role="button"
                                class="bg-danger p-2 px-3 border text-uppercase rounded newShifts"
                                (click)="redirectToPage('validateQr')"
                              >
                                <i
                                  class="fa-solid fa-map-location-dot text-white"
                                ></i>
                                <span class="fw-semibold small ms-1 text-white">
                                  Validate Checkpoints</span
                                >
                              </div>
                            }
                            @if (!largeView && isAdmin) {
                              <div
                                role="button"
                                class="pinned-message-card text-uppercase p-2 px-3"
                                (click)="redirectToPage('pinnedMessages')"
                              >
                                <i class="fa-solid fa-thumbtack text-dark"></i>
                                <span class="fw-semibold small ms-1">
                                  Pinned Messages
                                </span>
                              </div>
                            }

                            <!-- Unassigned Jobs -->
                            @if (jobStats?.unassigned_jobs) {
                              <div
                                role="button"
                                class="bg-danger p-2 px-3 border text-uppercase rounded fw-semibold small ms-1 text-white d-flex align-items-center newShifts"
                                (click)="redirectToPage('unassignedJobs')"
                              >
                                Unassigned Jobs
                              </div>
                            }
                            <!-- Stale Jobs -->
                            @if (jobStats?.stale_jobs) {
                              <div
                                title="Last update > 45 minutes"
                                role="button"
                                class="p-2 border rounded bg-danger text-white fw-semibold small px-3 d-flex align-items-center newShifts"
                                (click)="redirectToPage('staleJobs')"
                              >
                                Stale Jobs: {{ jobStats?.stale_jobs }}
                              </div>
                            }
                            <!-- Unassigned Shifts -->
                            @if (jobStats?.unassigned_shifts) {
                              <div
                                role="button"
                                class="bg-danger p-2 px-3 border text-uppercase rounded fw-semibold small ms-1 text-white d-flex align-items-center newShifts"
                                (click)="redirectToPage('unAssignedJobs')"
                              >
                                Unassigned Shifts
                              </div>
                            }
                            @if (jobStats?.pending_shifts) {
                              <div
                                role="button"
                                class="bg-danger p-2 px-3 border text-uppercase rounded fw-semibold small ms-1 text-white d-flex align-items-center newShifts"
                                (click)="redirectToPage('pendingShifts')"
                              >
                                Shifts Pending Acceptance
                              </div>
                            }
                            @if (jobStats?.stale_shifts) {
                              <div
                                role="button"
                                class="p-2 border rounded bg-danger text-white fw-semibold small px-3 d-flex align-items-center newShifts"
                                (click)="redirectToPage('staleShifts')"
                              >
                                Stale Shifts
                              </div>
                            }

                            @if (
                              (credStatData?.three_months ||
                                credStatData?.expired) &&
                              isAdmin
                            ) {
                              @if (credStatData?.three_months) {
                                <div
                                  class="p-2 border rounded bg-secondary-subtle text-dark fw-semibold small px-3 d-flex align-items-center gap-2"
                                  (click)="redirectToPage('3monthCred')"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title="Some credentials are expiring soon"
                                  role="button"
                                >
                                  <i
                                    class="fa fa-exclamation-triangle text-warning"
                                  ></i>
                                  Credentials Expiring
                                </div>
                              }

                              @if (credStatData?.expired) {
                                <div
                                  class="p-2 border rounded bg-danger text-white fw-semibold small px-3 d-flex align-items-center gap-2"
                                  (click)="redirectToPage('expiredCred')"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title="Some credentials have expired"
                                  role="button"
                                >
                                  <i class="fa fa-exclamation-triangle"></i>
                                  Expired Credentials
                                </div>
                              }
                            }
                          </div>
                        </div>
                      }
                      @if (isAdmin || isDispatchUser) {
                        <div class="col-12 col-lg-10">
                          <gtapp-user-live-jobs></gtapp-user-live-jobs>
                        </div>
                      }

                      @if (isAdmin || isDispatchUser) {
                        <div class="col-12 col-lg-10">
                          <gtapp-user-live-data
                            [routedToPage]="false"
                          ></gtapp-user-live-data>
                        </div>
                      }

                      @if (incidentsDataList?.length) {
                        <div class="p-2 py-3 p-lg-2 col-12 col-lg-auto">
                          <div class="d-flex gap-2">
                            <dt>Incident Reports</dt>
                            @if (moreActiveIncidentsAvailable) {
                              <button
                                class="btn btn-primary btn-sm"
                                (click)="redirectToPage('activeIncidents')"
                              >
                                Show All
                              </button>
                            }
                          </div>

                          <gtapp-gt-custom-table
                            [deskTopTableData]="incidentsDataList"
                            [desktopTableDetails]="incidentTableDetailData"
                            [otherParams]="{ hideHeaders: true }"
                            (rowClick)="onSelectIncident($event)"
                          >
                          </gtapp-gt-custom-table>
                        </div>
                      }

                      @if (
                        isAdmin && showPinnedMessagesComponent && largeView
                      ) {
                        <div class="col-12 col-lg-6">
                          <gtapp-pinned-message
                            shownFrom="home"
                            (emitData)="showPinnedMessagesComponent = $event"
                          ></gtapp-pinned-message>
                        </div>
                      }

                      <!-- Mobile Forms -->
                      @if (userPromptListData?.length > 0 && !largeView) {
                        <div class="p-2 py-3 p-lg-2">
                          <div class="mb-2">
                            <dt>Mobile Forms</dt>
                          </div>

                          <!-- prompt btns-->
                          <div class="d-flex flex-wrap gap-3">
                            @for (prompt of userPromptListData; track prompt) {
                              <div
                                role="button"
                                class="p-2 border rounded bg-secondary-subtle"
                                (click)="
                                  updateEvenDetails.promptData = prompt;
                                  updateTask = 'userPromptInfo'
                                "
                              >
                                <i
                                  class="fa-solid fa-clipboard-list text-success"
                                ></i>
                                <span class="fw-semibold small ms-1">{{
                                  prompt?.name
                                }}</span>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                    <!-- <div
                      role="button"
                      class="bg-secondary-subtle p-2 px-3 border text-uppercase rounded fw-semibold small d-flex align-items-center"
                      (click)="openLeaveRequestDialog()"
                    >
                      Request Leave
                    </div> -->
                  </div>
                </div>
              } @else if (queuedResposeListData?.length && !largeView) {
                <div
                  class="d-flex flex-wrap gap-lg-3 text-dark align-items-start"
                >
                  <div class="p-2 py-3 p-lg-2">
                    <div class="mb-2">
                      <dt>Navigation</dt>
                    </div>

                    <div class="d-flex flex-wrap gap-3">
                      <div
                        role="button"
                        class="bg-warning-subtle p-2 px-3 border text-uppercase rounded d-flex align-items-center"
                        (click)="openQueuedTemplate()"
                      >
                        <i class="fa-solid fa-book"></i>
                        <span class="fw-semibold small ms-1">
                          Queued Events [{{ queuedResposeListData?.length }}]
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>

            @if (!largeView) {
              <div class="m-0 p-0">
                <gtapp-update-events
                  [detailType]="updateTask"
                  (emitData)="closeDetailedHome()"
                >
                </gtapp-update-events>
              </div>
            }
          </div>
        }
      }

      <!--update tasks -->
      @if (
        [
          "scanCheckPoint",
          "addSiteComment",
          "addSitePhoto",
          "userPromptInfo",
        ].includes(updateTask)
      ) {
        <gtapp-update-events
          [detailType]="updateTask"
          [details]="updateEvenDetails"
          (emitData)="closeDetailedHome()"
        ></gtapp-update-events>
      }
      @if (updateTask == "updateJob" && !largeView) {
        <div class="section">
          <div class="bottom-section px-2 pt-2 pb-3" id="fixedBtn">
            @if (
              offlineMode
                ? offlineData?.siteData?.data?.length
                : subscriberStats?.company_count != 0
            ) {
              <div class="d-flex column-gap-1" id="patrolUpdateHomeBtns">
                <div
                  class="d-flex flex-column align-items-center justify-content-center w-100 bg-body-secondary text-body-emphasis btm-btn-height rounded border border-secondary gap-1"
                  (click)="updateTask = 'addSiteComment'"
                >
                  @if (screenWidth >= 375) {
                    <i class="fa-regular fa-message fs-5"></i>
                  }
                  <div
                    class="px-1 text-center"
                    [ngClass]="
                      screenWidth <= 375 ? 'small-font text-uppercase' : ''
                    "
                  >
                    Add Comment
                  </div>
                </div>
                <div
                  id="scanCheckpointTemplateId"
                  class="d-flex flex-column align-items-center justify-content-center w-100 bg-primary-subtle text-primary-emphasis btm-btn-height text-center rounded border border-primary"
                  (click)="openScanCPTemplate()"
                >
                  <div
                    class="px-2"
                    [ngClass]="
                      screenWidth <= 375 ? 'small-font text-uppercase' : ''
                    "
                  >
                    Scan Checkpoint
                  </div>
                </div>
                <div
                  class="d-flex flex-column align-items-center justify-content-center w-100 bg-body-secondary text-body-emphasis btm-btn-height rounded border border-secondary gap-1"
                  (click)="updateTask = 'addSitePhoto'"
                >
                  @if (screenWidth >= 375) {
                    <i class="fa-solid fa-camera fs-5"></i>
                  }
                  <div
                    class="px-1 text-center"
                    [ngClass]="
                      screenWidth <= 375 ? 'small-font text-uppercase' : ''
                    "
                  >
                    Upload Photo
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }

      <!-- show user they dont have internet connection on large screem-->
      @if (largeView && offlineMode) {
        <div class="section d-none d-md-block">
          <div class="alert alert-danger text-center">
            Connection to Server Lost
            <div class="small">Please check your Internet connection</div>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<ng-template #confirmSOSTemplate let-confirmSOSTemplate="dialogRef">
  <div class="dialog-box card p-2">
    <div class="card-header">
      SOS Sent
      <span class="float-end" (click)="confirmSOSTemplate.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="alert alert-success">
        SOS has been sent, parties have been informed to contact you.
      </div>
    </div>
    <div>
      <button
        type="button"
        class="btn btn-success btn-lg w-100"
        (click)="confirmSOSTemplate.close()"
      >
        OK
      </button>
    </div>
  </div>
</ng-template>

<!-- missed event reason providing template-->
<ng-template
  #missedEventReasonTemplateRef
  let-missedEventReasonTemplateRef="dialogRef"
>
  <div class="dialog-box card p-2">
    <div class="card-header">
      Missed Welfare Checks
      <span class="float-end" (click)="missedEventReasonTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="row row-cols-1 row-cols-md-2 row-cols-xxl-3 row-cols-xxxl-6">
      @for (event of missedWelfareData; track event) {
        <div class="col gy-2 mb-3 gt-card">
          <div class="text-center mb-1">
            {{ event.missed_at | date: "d MMM" }}
            <span class="fw-bold">{{ event.missed_at | date: "HH:mm" }}</span>
          </div>
          <div class="mb-2">
            <textarea
              class="form-control"
              type="text"
              placeholder="Reason for missing welfare check"
              [(ngModel)]="event.missedReason"
              rows="1"
            ></textarea>
          </div>
          <div class="mb-3">
            <button
              type="button"
              class="btn btn-primary btn-lg w-100"
              [disabled]="!event?.missedReason"
              (click)="
                updateMissedReason(event);
                missedWelfareData?.length == 1
                  ? missedEventReasonTemplateRef.close()
                  : ''
              "
            >
              Submit
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template
  #pinnedMessageTemplate
  let-data
  let-pinnedMessageTemplateRef="dialogRef"
>
  <div class="dialog-box card">
    <div class="card-header fw-semibold">Pinned Message</div>
    <div class="p-3 border border-danger text-danger bg-white rounded fs-5">
      <div class="gt-multi-line mb-3">
        {{ data?.message }}
      </div>
    </div>

    <div
      class="d-flex align-items-center my-3 justify-content-center fw-semibold fs-5"
      [class.pb-5]="!data?.read"
    >
      <input
        type="checkbox"
        id="prioritySiteSelection"
        [checked]="data?.read"
        (change)="data.read = !data?.read"
      /><label class="ms-2" for="prioritySiteSelection" role="button"
        >I have read and understood the above</label
      >
    </div>

    @if (data?.read) {
      <div class="row pb-5">
        <button
          class="btn btn-lg w-100 btn-primary"
          [disabled]="!data?.read"
          (click)="pinnedMessageTemplateRef.close()"
        >
          OK
        </button>
      </div>
    }
  </div>
</ng-template>
